import {isString, keys as getKeys, map} from 'lodash';

export type IEnumItem = {
   id: string;
   name?: string;
};

export type IEnum = {
   [key: string]: IEnumItem | string;
};

export function enumType<T extends IEnum>(obj: T) {
   let _enum = {} as {[K in keyof T]: K},
      keys: Array<keyof typeof obj>;

   const options: Array<{id: keyof T; name: string}> = map(obj, (val, key) => ({
      id: key,
      name: isString(val) ? val : (val as IEnumItem).name || (val as IEnumItem).id,
   }));

   for (let i in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, i)) {
         _enum[i] = i;
      }
   }

   keys = getKeys(obj);

   return Object.assign(obj, {
      options,
      enum: _enum,
      keys,
      origin: obj,
   });
}
